import { render, staticRenderFns } from "./createFrac.vue?vue&type=template&id=88ae123a&scoped=true"
import script from "./createFrac.vue?vue&type=script&lang=js"
export * from "./createFrac.vue?vue&type=script&lang=js"
import style0 from "./createFrac.vue?vue&type=style&index=0&id=88ae123a&prod&lang=css"
import style1 from "./createFrac.vue?vue&type=style&index=1&id=88ae123a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ae123a",
  null
  
)

export default component.exports